import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ConfigService } from '../local/config.service';
import { MessageService } from '../local/message.service';
import { Account } from '../../_models/Account';
import { Endpoints } from 'src/app/_constants/endpoints';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  protected readonly baseUrl: string;

  constructor(
    private readonly messageService: MessageService,
    private readonly http: HttpClient,
    private readonly configService: ConfigService
  ) {
    this.baseUrl = this.configService.Config.apiUrl;
  }

  public login(): Observable<Account | { redirectUrl: string } | undefined> {
    return this.http
      .get<Account | { redirectUrl: string }>(this.baseUrl + Endpoints.LOGIN_API)
      .pipe(catchError((error) => this.handleError(error)));
  }

  public logout(): Observable<{ redirectUrl: string } | undefined> {
    return this.http
      .post<{ redirectUrl: string }>(this.baseUrl + Endpoints.LOGOUT_API, {})
      .pipe(catchError((error) => this.handleError(error)));
  }

  public profil(): Observable<Account | undefined> {
    return this.http.get<Account>(this.baseUrl + Endpoints.PROFILE_API).pipe(catchError(() => of(undefined)));
  }

  private handleError(error: HttpErrorResponse): Observable<undefined> {
    if (error.status >= 500) {
      this.messageService.error(`auth : ${error.statusText}`);
    } else {
      switch (error.status) {
        case 404:
          this.messageService.info(`Introuvable`);
          break;
        default:
          // @ts-ignore
          this.messageService.error(error.title || error.message);
          break;
      }
    }

    return of(undefined);
  }
}
